import {Component, OnInit} from '@angular/core';
import {AppToastrService, RoutingService, TravelsService,  StorageService, DocumentsService} from 'app/services';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-travel-profile',
  templateUrl: './travel-profile.component.html',
  styleUrls: ['./travel-profile.component.scss']
})

export class TravelProfileComponent implements OnInit{
  typeAction: string;
  travelId: number;
  travel: any;
  contact: any;
  isLoaded: boolean;
  disablingBtn = true;
  showEditTravel: boolean;
  fileValue: any;
  fileLoading: boolean;
  confirm: any;
  showInvoicePopup: boolean;
  pageTitle: any;
  pageClientName: any;
  showServicePopup = false;
  showPassengerPopup = false;
  showPassengerDocsPopup = false;
  selectedService: any;
  selectedLocation: any;
  passenger: any = null;
  refreshLib = true;

  travelStatuses: any[] = [];
  serviceStatuses: any[] = [];
  dictionarySubscription: any;

  fileDownloading: boolean;
  showFileViewer: boolean;
  file: any;

  selectStatusSettings = {
    classes: 'travel',
    primaryKey: 'id',
    labelKey: 'name',
    singleSelection: true,
  };
  selectServiceStatusSettings = {
    classes: 'travel',
    primaryKey: 'id',
    labelKey: 'name',
    singleSelection: true,
  };
  optionsPassenger = {
    header: ['ФИО', 'Категория', 'Дата Рождения', '','Документы']
  };
  showRequestServicePopup: boolean;
  public Editor = ClassicEditor;

  constructor(private routingService: RoutingService,
              private travelsService: TravelsService,
              private documentsService: DocumentsService,
              private toast: AppToastrService,
              private storage: StorageService,
              private route: RoutingService,
) {
    // this.travel = routingService.params.travel;
    this.travelId = routingService.params.id;
    this.pageTitle = this.routingService.params.name;
  }

  ngOnInit() {
    this.getTravel();
  }

  redirectToPage(url) {
    this.route.go(url);
  }


  private getTravel() {
    this.isLoaded = false;
    this.travelsService.getTravel(this.travelId).subscribe((res) => {
      if (res) {
        this.travel = res;
        this.isLoaded = true;
        console.log('!!!!travel', this.travel);
      }
    }, (err) => {
      this.toast.showToastFromError(err);
      this.isLoaded = true;
    });
}

  openItem(line: any) {
    line.isOpened = !line.isOpened;
  }

  openRequestServicePopup(typeAction) {
    this.typeAction = typeAction;
    this.showRequestServicePopup = true;
  }

  cancelTravel() {
    this.confirm = {
      action: 'Запросить отмену путешествия',
      message: `Пожалуйста нажмите кнопку "Отправить запрос" чтобы запросить отмену путешествия.`,
      type: 'delete',
      show: true,
      data: {}
    };
  }

  onConfirmNotify(e) {
    this.confirm = null;
    if (e.type === 'success' && e.data.type === 'deleteMember') {
      // this._deleteMember(e.data.data.member, e.data.data.index);
      // } else if (e.type === 'success' && e.data.type === 'deleteDiscount') {
      //   this._deleteDiscount(e.data.data.discount, e.data.data.index);
    }
  }

  onNotify(event: any) {
    this.showRequestServicePopup = false;

    // if (event.type === 'createClient') {
    //   this.client = event.data;
    // } else if (event.type === 'createMember') {
    //   this.client.members.push(event.data);
    // } else if (event.type === 'updateMember') {
    //   this.client.members[event.index] = event.data;
    // } else if (event.type === 'updateClient') {
    //   this.notify.emit({
    //     type: 'updateClient',
    //     data: event.data
    //   });
    // }
  }

  //////////********************* Documents **************************////////////////////
  downloadFile(file: any) {
    this.documentsService.getFile(file).subscribe(
        (res: any) => {
          if (res) {
            FileSaver.saveAs(res, file.name);
          }
        },
        err => {
          this.toast.showToastFromError(err);
        }
    );
  }

  formatName(name) {
    return name.trim().replace(/,\s*$/, '');
  }
}
